import React from "react";
import Section from "../components/Section";
import { Image } from "../components";

const ImageSection = () => {
	return (
		<Section title={"# Image"}>
			<div className="d-flex align-items-center gap2">
				<Image src="https://imgur.com/gPswqEf.png" alt="placeholder" height={"150px"} width={"auto"} />
				<hr />
				<Image src="https://imgur.com/u5y84xO.png" alt="placeholder" height={"auto"} width={"40%"} />
			</div>
		</Section>
	);
};

export default ImageSection;
